import React from "react";
import { FaPhoneAlt, FaEnvelope, FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";

function TopBar({ isScrolled }) {
  return (
    <div className={`top-bar ${isScrolled ? "scrolled" : ""}`}>
      <div className="container">
        <div className="top-bar-content">
          <div className="top-bar-left">
            <a href="tel:+923033330023" className="top-bar-item">
              <FaPhoneAlt className="top-bar-icon" />: <span>+92-303-3330023</span>
            </a>
            <span className="top-bar-separator">|</span>
            <a href="mailto:info@dright.net" className="top-bar-item">
              <FaEnvelope className="top-bar-icon" />: <span>info@dright.net</span>
            </a>
          </div>
          <div className="top-bar-right">
            <a
              href="https://www.facebook.com/D.Right.Technologies"
              target="_blank"
              rel="noopener noreferrer"
              className="top-bar-social"
              aria-label="Facebook"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/d.right.technologies/"
              target="_blank"
              rel="noopener noreferrer"
              className="top-bar-social"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/d-right-technologies"
              target="_blank"
              rel="noopener noreferrer"
              className="top-bar-social"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopBar;
